export const addResponseDataToQuizAnnotations = (responseData, annotations) => {
    // Get An array of annotations excluding quizzes and asnwers. 
    const annotationsNoQuizzesOrAnswers = annotations.filter(a => a.type !== 'quiz' && a.type !== 'answer')
    // Array of only Quizzes. This will be needed for updating the activities panel Page.
    const quizzes = annotations.filter(a => a.type === 'quiz')
    // Array of only answers. This is needed for showing correct / incorrect.
    const allAnswers = annotations.filter(a => a.type === 'answer')
    // Array answers ids of submitted answers from Response Data. This could be all four questions or just 1. 
    const responseAnswerIds = responseData.map(response => response.answerId)
    
    // define a new array of quizzes that contains the response data used to update the video activities panel.  
    const newQuizzes = quizzes.map(quiz => {
        const dataForQuiz = responseData.find(data => data.quizId === quiz.id)

        quiz.responseData = dataForQuiz;
        return quiz;
    })
    
    // Array used to track the question Ids for each answer that has been provided a response.  
    const questionIdsThatApply = []

    // Create a new answer array where each answer is updated with a new boolean that determines
    // if the student response is correct, and if student repsonse was provided.
    let newAnswers = allAnswers.map(answer => {
        let updatedAnswer = answer;
        const thisAnswersResponse = responseAnswerIds.includes(answer.id) 
            ? responseData.find(response => response.answerId === answer.id) 
            : null;
        const correspondingQuestionId = answer.appliesTo[0] // Answers only apply to one question, so checking for the 0 index is okay here. 

        // If the current answer has a student provided response, add that property to the answer object with the correct boolean value.
        if (thisAnswersResponse) {
            const responseAnswerId = responseData.find(response => response.answerId === answer.id).answerId;

            questionIdsThatApply.push(correspondingQuestionId) // this is the corresponding question Id
            
            updatedAnswer = {
                ...answer,
                studentResponseIsCorrect: thisAnswersResponse.isCorrect,
                studentSelectedAnswerId: responseAnswerId
            }
        }

        return updatedAnswer
    })

    // Double check and make sure that ALL answers that have a student provided response are aware that the response exists. 
    newAnswers = updateAllAnswersWithSubmissionData(newAnswers, questionIdsThatApply)

    return [
        ...newQuizzes,
        ...newAnswers,
        ...annotationsNoQuizzesOrAnswers
    ]
}

const updateAllAnswersWithSubmissionData = (answers, questionIdsThatApply) => {
    // Get all nswers options that correspond to the questions that have been answered.
    const allQuestionAnswers = answers.filter(answer => questionIdsThatApply.includes(answer.appliesTo[0])); // This is okay, an answer can only apply to one question.
    // Get all answer options for questions that were not answered.
    const allNonAnsweredAnswers = answers.filter(answer => !questionIdsThatApply.includes(answer.appliesTo[0]));
    // Add Submitted flag to the answer.
    const answersWithSubmittedData = allQuestionAnswers.map(answer => {
        return {
            ...answer,
            hasPreviouslySubmittedStudentResponse: true
        }
    })

    return [
        ...answersWithSubmittedData,
        ...allNonAnsweredAnswers
    ]
}